<template>
  <div>
    <v-row>
      <v-col>
        <v-data-table
            :headers="tabla.headers"
            :items="tabla.items"
            :options.sync="tabla.options"
            :server-items-length="tabla.count"
            :fixed-header="true"
            class="elevation-3"
            calculate-widths
            :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
            :no-data-text="$t('No hay datos')"
            :no-results-text="$t('No hay datos')"
        >
          <template v-slot:item="{ item }">

            <tr
                v-if="!current_deuda_id || current_deuda_id===item.id"
                @click="current_deuda_id=current_deuda_id?null:item.id"
                style="cursor: pointer"
            >
              <td>{{ item.fecha | moment('DD/MM/YYYY') }}</td>
              <td>{{ item.importe_inicial | money }}</td>
              <td>{{ item.importe_restante | money }}</td>

              <!-- VENTA -->
              <td>
                <ToolTipVenta
                    v-if="item.venta"
                    :venta="item.venta"
                />
              </td>
            </tr>

            <tr v-if="current_deuda_id===item.id">
              <td colspan="5">
                <h4>{{ $t("Movimientos de la deuda") }}</h4>
              </td>
            </tr>

            <tr v-if="current_deuda_id===item.id">
              <td colspan="5">
                <!-- TABLA MOVIMIENTOS DEUDA -->
                <TablaMovimientosDeuda
                    class="my-1 mx-0"
                    :selected_filters="{'cliente_id':selected_filters.cliente_id,'deuda_id': item.id, 'tipo__in': 'deuda'}"
                    :refresh="refresh"
                    hide_footer
                    ref="movimientosDeuda"
                    :hide_delete_button="true"
                    @on_delete_movimiento_deuda="delete_movimiento_deuda"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row v-if="current_deuda_id && current_deuda_obj.venta.centro_id === $store.state.centro.centro.id">
      <v-col class="ma-3">
        <h4 class="mb-2">{{ $t("Nueva entrega de deuda") }}</h4>
        <FormEntregaDeuda
            :deuda="current_deuda_obj"
            @on_save="on_event_deuda_refresh"
            @on_delete="on_event_deuda_refresh"
        />
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { ref, watch } from '@vue/composition-api'
import useTable from "@/composables/useTable"

export default {
  name: 'TablaDeudas',
  props: {
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    }
  },

  data(){
    return{
      refresh:0
    }
  },

  setup(props, {root}){

    const { tabla, get_items } = useTable('cliente/get_deudas')

    const get_deudas = () => {

      let filtros = { ...tabla.filtros, ...props['selected_filters'] }

      get_items(filtros)
    }

    tabla.value.headers = [
      { text: root.$t('Fecha'), value: 'fecha', class: "primary white--text" },
      { text: root.$t('Importe inicial'), value: 'importe_inicial', class: "primary white--text" },
      { text: root.$t('Importe restante'), value: 'importe_restante', class: "primary white--text" },
      { text: root.$t('Venta'), value: 'venta', class: "primary white--text", sortable: false, width: "80px" }
    ]

    const current_deuda_id = ref(null)
    const current_deuda_obj = ref({})

    const on_event_deuda = async () => {
      get_deudas()
      if (root.$refs.movimientosDeuda)
        await root.$refs.movimientosDeuda.refresh_items()
    }

    watch(() => current_deuda_id.value,
        /**
         * Cada vez que se selecciona una deuda, actualizamos el objeto que es un prop del formulario
         * @param value
         */
        (value) => {
          current_deuda_obj.value = tabla.value.items.filter(d => d.id === value)[0]
        }
    )

    return {
      tabla,
      current_deuda_id,
      current_deuda_obj,
      on_event_deuda,
      get_deudas
    }
  },

  mounted() {
    this.tabla.filtros.limit = 5
    this.tabla.options.itemsPerPage = 5
    this.get_deudas()
  },

  components: {
    FormEntregaDeuda: () => import('@/views/Clientes/Components/FormEntregaDeuda'),
    TablaMovimientosDeuda: () => import('@/views/Clientes/Components/TablaMovimientosDeuda'),
    ToolTipVenta: () => import('@/views/Ventas/components/ToolTipVenta')
  },
  methods: {
    on_event_deuda_refresh(){
      this.on_event_deuda()
      this.$emit('has_to_refresh')
      this.current_deuda_id = null
    },

    async delete_movimiento_deuda (movimiento) {
      const resp = await this.$confirm(this.$t('¿Desea eliminar el abono seleccionado?').toString(), null, null, {
        cancelButtonText: this.$t('Cancelar').toString(),
        confirmButtonText: this.$t('Aceptar').toString()
      })
      if (resp) {
        try {
          await this.$store.dispatch('caja/delete_movimiento', movimiento)
          this.$snotify.success(
              this.$t('Acción realizada con éxito'),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          this.on_event_deuda_refresh()
        } catch (err) {
          this.$snotify.error(
              this.$t('Ha ocurrido un error'),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }
    }
  },

  watch:{
    'tabla.items':{
      async handler(){
        if (this.$refs.movimientosDeuda)
          await this.$refs.movimientosDeuda.refresh_items()
      }
    }
  }
}
</script>
